import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { GeoAlt } from 'react-bootstrap-icons'
import Selector from '../../locations/selector'
import useViewport from '../../../hooks/use-viewport'

const InputComponent = ({
    value = '',
    onChange = () => {}
}) => {
    const { breakpoint, breakpoints } = useViewport()
    return (
        <Form.Group as={Row} controlId="formHorizontalEmail">
            <Form.Label column sm={12} md={1} lg={2} xl={6}>
                <GeoAlt size={30} /> {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Location' : ''}
            </Form.Label>
            <Col sm={12} md={11} lg={10} xl={6}>
                <Selector value={value} onChange={onChange} />
            </Col>
        </Form.Group>
    )
}

export default InputComponent